import { render, staticRenderFns } from "./giftBagList.vue?vue&type=template&id=76d23882&scoped=true&"
import script from "./giftBagList.vue?vue&type=script&lang=js&"
export * from "./giftBagList.vue?vue&type=script&lang=js&"
import style0 from "./giftBagList.vue?vue&type=style&index=0&id=76d23882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d23882",
  null
  
)

export default component.exports